/** Where one ID-card copy stands on its way to having its issue date blacked out (HAT-1303). */
export enum IdRedactionStatus {
  /** Stored as it arrived. Openable in the redaction screen, and nowhere else. */
  Pending = 'Pending',
  /** The boxes were burned into the pixels and the original file was deleted from storage. */
  Redacted = 'Redacted',
}
